module.exports = __webpack_public_path__ + "static/media/file-minus.099729db.svg";